<template>
  <div class="importInvestmens">
    <v-tabs v-model="importTabIndex">
      <v-tabs-items v-model="importTabIndex">
        <v-tab-item>
          <v-form ref="form" class="mt-4" lazy-validation>
            <v-row>
              <v-col cols="4" :style="{ maxWidth: formMaxWidth + 'px' }">
                <div>
                  <v-select
                    v-model="importType"
                    :items="importTypesList"
                    item-value="Value"
                    item-text="Text"
                    label="Import type"
                    :rules="rules"
                    :loading="isLoadingTypes"
                    outlined
                    dense
                  ></v-select>
                </div>
                <div>
                  <v-select
                    v-model="importName"
                    :items="importNameList"
                    item-value="Value"
                    item-text="Text"
                    label="Import name"
                    :rules="rules"
                    :loading="isLoadingNames"
                    outlined
                    dense
                  ></v-select>
                </div>
                <div v-if="importType === 'Monthly Payroll' && multiCurrency">
                  <v-select
                    v-model="currency"
                    :items="currencyList"
                    label="Currency"
                    :rules="rules"
                    outlined
                    dense
                  ></v-select>
                </div>
                <div v-if="importType === 'Monthly Payroll' && multiCurrency">
                  <v-text-field
                    v-model="exchangeRate"
                    type="number"
                    step="0.0001"
                    label="Exchange rate"
                    :rules="rules"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div>
                  <DatePicker
                    v-if="importType === 'Monthly Payroll'"
                    v-model="payrollDate"
                    label="Payroll date"
                    :rules="rules"
                  />
                </div>
                <div>
                  <v-file-input
                    v-model="importFile"
                    ref="file"
                    label="Import file"
                    accept=".csv, text/plain, .tab"
                    :rules="rules"
                    dense
                  ></v-file-input>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-tab-item>

        <v-tab-item>
          <ImportTable
            :startImportResults="startImportResults"
            :isLoadingStart="isLoadingStart"
            :isLoadingValidation="isLoadingValidation"
          />
        </v-tab-item>

        <v-tab-item>
          <ImportErrors
            :errorList="errorList"
            :importKey="startImportResults.ImportKey"
            :importId="this.payrollImportId"
            :isLoadingValidation="isLoadingValidation"
            :isLoadingSave="isLoadingSave"
            :isImportSuccessful="isImportSuccessful"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <v-footer padless fixed outlined class="pl-5 pr-5 pt-3 pb-3" color="white" elevation="3">
      <v-btn @click="removePayrollClick"> Remove Payroll </v-btn>
      <v-spacer></v-spacer>

      <ImportBtns
        :importKey="startImportResults.ImportKey"
        :importTabIndex="importTabIndex"
        :errorList="errorList"
        :isFormValid="isFormValid"
        :startImportErrors="startImportErrors"
        :enableNextOnValidation="enableNextOnValidation"
        :processed="isProcessed"
        @buttonClick="onButtonClick"
      />
    </v-footer>
    <div class="text-center">
      <v-dialog v-model="removePayrollDialog" :width="800" @keydown.esc="cancel">
        <v-card>
          <v-card-title class="text-h5 lighten-2"> Remove Imported Payroll </v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-card-text>
            <div class="mt-3">
              <v-select
                label="Select Payroll"
                :items="payrollList"
                item-text="ShortName"
                item-value="ShortName"
                v-model="selectedPayroll"
                @change="getImportedPayrollList"
              >
              </v-select>
            </div>
            <div>
              {{ importedPayroll || !selectedPayroll ? importedPayroll : 'No imports found.' }}
            </div>
          </v-card-text>
          <!-- <v-divider></v-divider> -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="removePayrollDialog = false"> Cancel </v-btn>
            <v-btn
              color="primary"
              depressed
              @click.native="removePayroll"
              :disabled="importedPayroll === ''"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/formControls/DatePicker.vue';
import ImportTable from '@/views/Investments/ImportTable.vue';
import ImportErrors from '@/views/Investments/ImportErrors.vue';
import ImportBtns from './ImportBtns.vue';

export default {
  name: 'ImportInvestmens',
  components: { DatePicker, ImportTable, ImportErrors, ImportBtns },
  props: {},
  data: () => ({
    isLoadingTypes: false,
    isLoadingNames: false,
    isLoadingStart: false,
    isLoadingValidation: false,
    isLoadingSave: false,
    isProcessed: false,

    importTypesList: [],
    importType: null,
    importNameList: [],
    importName: null,
    payrollDate: new Date().toISOString(),
    importFile: null,
    currencyList: ['JM', 'CHY', 'EUR', 'GBP', 'RIM', 'USD'],
    currency: 'EUR',
    exchangeRate: '1.0000',
    multiCurrency: false,

    importTabIndex: 0,
    enableNextOnValidation: false,

    formMaxWidth: 500,
    isFormValid: false,
    rules: [(v) => !!v || 'Required'],

    startImportResults: {},
    errorList: [],
    startImportErrors: 0,
    payrollImportId: 0,

    isImportSuccessful: false,
    removePayrollDialog: false,
    importedPayroll: '',
    payrollList: [],
    selectedPayroll: null,
  }),

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
  },

  watch: {
    importType(newValue) {
      this.getImportDefinitionList(newValue);
    },
  },

  created() {
    this.getImportTypesList();
  },

  methods: {
    async getImportedPayrollList() {
      try {
        let response = await this.$api.get(
          '/Import/GetLatestImportedPayroll?payroll=' +
            this.selectedPayroll +
            '&planId=' +
            this.currentPlanId
        );
        this.importedPayroll = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    async removePayrollClick() {
      this.removePayrollDialog = true;
      try {
        let response = await this.$api.get(
          '/Picklists/GetPicklist?planId=' + this.currentPlanId + '&listType=Payroll'
        );
        this.payrollList = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    async removePayroll() {
      try {
        var data = { planId: this.currentPlanId, payrollName: this.selectedPayroll };
        let response = await this.$api.post('/Import/RemovePayroll', data);
        this.payrollList = response.data;
        this.removePayrollDialog = false;
        this.selectedPayroll = '';
        this.importedPayroll = '';
      } catch (err) {
        console.log(err);
      }
    },
    onButtonClick(val) {
      if (val === 'cancel') {
        this.importTabIndex = 0;
        this.importType = null;
        this.importName = null;
        this.payrollDate = null;
        this.importFile = null;
        this.currency = 'EUR';
        this.exchangeRate = '1.0000';
      }
      if (val === 'start') {
        this.isFormValid = this.$refs.form.validate();
        if (this.isFormValid) {
          this.importTabIndex += 1;
          let data = new FormData();
          data.append('PlanId', this.currentPlanId);
          data.append('ImportType', this.importType);
          data.append('ImportId', this.importName);
          data.append(
            'ImportName',
            this.importNameList.find((name) => name.Value === this.importName).Text
          );
          data.append('PayrollDate', this.payrollDate);
          if (this.currency) data.append('Currency', this.currency);
          if (this.exchangeRate) data.append('ExchangeRate', this.exchangeRate);
          data.append(
            'File',
            new Blob([this.importFile], {
              type: this.importFile.type,
            })
          );

          this.startImport(data);
        }
      }
      if (val === 'validate') {
        this.importTabIndex = 2;
        this.validateData();
      }
      if (val === 'save') {
        this.saveImport();
      }
    },

    async getImportTypesList() {
      this.isLoadingTypes = true;
      try {
        const response = await this.$api.get('/Import/GetImportTypes');
        this.importTypesList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isLoadingTypes = false;
      }
    },

    async getImportDefinitionList(importType) {
      this.isLoadingNames = true;
      try {
        const response = await this.$api.get(
          `/Import/GetImportDefinitionList?planId=${this.currentPlanId}&importType=${importType}`
        );

        this.importNameList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isLoadingNames = false;
      }
    },

    async startImport(importData) {
      this.isLoadingStart = true;

      try {
        const response = await this.$api({
          url: '/Import/StartImport',
          method: 'POST',
          data: importData,
        });
        if (!response.data) {
          const msg = 'Unable to start import';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        this.startImportResults = response.data;
        this.startImportErrors = response.data.Errors;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isLoadingStart = false;
      }
    },

    async validateData() {
      this.isLoadingValidation = true;
      try {
        const response = await this.$api.get(
          '/Import/ValidateImportData?importKey=' + this.startImportResults.ImportKey
        );
        if (!response.data) {
          const msg = 'Unable to validate data';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        this.errorList = response.data.ErrorList;
        this.enableNextOnValidation = true;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isLoadingValidation = false;
      }
    },

    async saveImport() {
      this.isLoadingSave = true;
      try {
        let response = await this.$api.get(
          '/Import/SaveImport?importKey=' + this.startImportResults.ImportKey
        );

        if (response.data.Errors < 0) {
          this.isImportSuccessful = false;
          this.isProcessed = false;

          if (response.data.ErrorList.length) {
            this.errorList.push(...response.data.ErrorList);
          }

          const msg = 'Errors saving import';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(response.data);
          
        } else {
          if (response.data.PayrollImportId > 0){
            this.payrollImportId = response.data.PayrollImportId;
          }
          this.isImportSuccessful = true;
          this.isProcessed = true;
        }
      } catch (error) {
        console.log(error.message);
        this.isImportSuccessful = false;
        this.isProcessed = false;
      } finally {
        this.isLoadingSave = false;
      }
    },
  },
};
</script>

<style lang="scss">
.importInvestmens {
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
</style>
